export default "__VITE_ASSET__Dx_NTYzi__"